/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useIntl } from "react-intl";

import { PurposedButtonProps } from "./types";
import { useTheme } from "../../../../config/emotion";
import EwaButton2 from "./EwaButton/EwaButton2";
import { labellessButtonCss } from "./styles";

const TableExportButton = (props: PurposedButtonProps) => {
  const { formatMessage } = useIntl();
  const { colors } = useTheme();

  return (
    <EwaButton2
      data-cy="table-export-button"
      buttonColor={colors.secondaryColor}
      tooltip={formatMessage({ id: "table.export_table" })}
      css={labellessButtonCss}
      iconName="system_update_alt"
      {...props}
    />
  );
};

export default TableExportButton;
